// @flow
import React from 'react';
import Radio from './Radio';

type Props = {
  handleStaffGroupNotificationRadioSelectionYes: () => void,
  handleStaffGroupNotificationRadioSelectionNo: () => void,
  canSendFlyersToStaff: boolean,
};

const StaffGroups = ({
  handleStaffGroupNotificationRadioSelectionYes,
  handleStaffGroupNotificationRadioSelectionNo,
  canSendFlyersToStaff,
}: Props) => (
  <div className="d-flex">
    <div>
      <p className="pt-1">
        Would you like community organizations to be able to send flyers to your
        staff?
      </p>
    </div>
    <div className="pl-4 pt-0">
      Yes<Radio
        id="yes"
        color="jungle"
        onClick={handleStaffGroupNotificationRadioSelectionYes}
        checked={canSendFlyersToStaff === true}
      />
      No<Radio
        id="no"
        color="jungle"
        onClick={handleStaffGroupNotificationRadioSelectionNo}
        checked={canSendFlyersToStaff === false}
      />
    </div>
  </div>
);

export default StaffGroups;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/organization/components/StaffGroups.jsx